// extracted by mini-css-extract-plugin
export default {"card":"portfolioCard_card__jHZY-","game":"portfolioCard_game__3k+Oe","info":"portfolioCard_info__r0mrV","mobile_info":"portfolioCard_mobile_info__xEz60"};